export default "__VITE_ASSET__DVsvbPD6__"